// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LegendRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LegendRightIcon" ref={forwardedRef} {...props}>
      <path d="M3 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h3v11h-3z" />
      <path d="M18 5.5h-8V4h8z" />
      <path d="M10 9h8V7.5h-8z" />
      <path d="M18 12.5h-8V11h8z" />
      <path d="M10 16h8v-1.5h-8z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LegendRightIcon = /* @__PURE__ */ Object.assign(
  LegendRightIconComponent,
  { displayName: 'LegendRightIcon' },
);
